import ReportLineChart from "./ReportLineChart.vue";

export default ReportLineChart;
